import React from 'react';
import { NavbarContent } from "@heroui/navbar";
import AccountDropdown from '@/components/Common/AccountDropdown';
import { User } from '@/types/models/user';
import UnauthenticatedNav from '@/components/Layouts/Default/Partials/Navbar/components/desktop/UnauthenticatedNav';

const NavbarAuth = ({ isAuthenticated }: { isAuthenticated: boolean }) => {
  return (
    <NavbarContent className="!flex-initial">
      {isAuthenticated ? <AccountDropdown /> : <UnauthenticatedNav />}
    </NavbarContent>
  );
};

export default NavbarAuth;
